const devAPI = 'http://localhost:3030';
// const devAPI = 'https://fp.api-study.kesemsolutions.com';
const prodAPI = 'https://fp.api-study.kesemsolutions.com';

export const getAPIDomain = () => {
  if (
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1'
  ) {
    return devAPI;
  } else {
    return prodAPI;
  }
};
export const userRole = () =>  localStorage.getItem("role") || null;
export const isAdmin = () => localStorage.getItem("role") === "admin";
